import {LoadingOutlined} from '@ant-design/icons'
import {referral_deleteReferral_Api, referral_getReferrals_Api} from 'apis'
import classnames from 'classnames'
import EmptyHolder from 'components/EmptyHolder'
import Timestamp from 'components/Feed/Timestamp'
import Modal from 'components/Modal/Modal'
import AsyncAction from 'modules/asyncCache/components/AsyncAction'
import {LazyPagination} from 'modules/asyncCache/components/LazyPagination'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React from 'react'
import useToggle from 'react-use/lib/useToggle'
import Invite from './Invite'
import {ROOT_URL} from "../../../envs/_current/config";
import _ from "lodash";
import {BsTrash} from "react-icons/bs";
import {MdOutlineFileCopy} from "react-icons/md";
import {copyLink} from "../../../helpers";
import TooltipApp from "components/TooltipApp";
import {Button} from "antd";

const InviteRow = ({
                       className,
                       inviter,
                       invite_code,
                       uses,
                       actions,
                       expires
                   }) => (
    <div
        className={classnames(
            'flex items-center',
            className
        )}>
        <div
            style={{flex: '3 1 0px'}}
            className="hidden md:block">
            {inviter}
        </div>
        <div style={{flex: '3 1 0px'}}>
            {invite_code}
        </div>
        <div style={{flex: '1 1 0px'}}>
            {uses}
        </div>
        <div style={{flex: '2 1 0px'}}>
            {expires}
        </div>
        {
            <div style={{flex: '1 1 0px'}}>
                {actions}
            </div>
        }
    </div>
)
const InviteRowHeader = withTranslate(
    ({translate}) => (
        <InviteRow
            {...{
                inviter: (
                    <div className="text-xs uppercase text-color-300 font-semibold truncate hidden md:block">
                        {translate('inviter')}
                    </div>
                ),
                invite_code: (
                    <div className="text-xs uppercase text-color-300 font-semibold truncate">
                        {translate('invite code')}
                    </div>
                ),
                uses: (
                    <div className="text-xs text-right uppercase text-color-300 font-semibold truncate">
                        {translate('uses')}
                    </div>
                ),
                expires: (
                    <div className="text-xs text-right uppercase text-color-300 font-semibold truncate">
                        {translate('expires')}
                    </div>
                )
            }}
        />
    )
)

function InviteManager({item}) {
    const t = useTranslate()
    const containerType = item._type
    const containerId = item.id
    const [isToggle, toggle] = useToggle()
    const [
        listKey,
        setListKey
    ] = useToggle()
    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between gap-3">
                <span className="text-xs text-color-400 italic">
                    {t('Here is a list of all invite links. You can revoke any one.')}
                </span>
                <Button
                    color="primary" variant="filled"
                    onClick={() => toggle()}
                    className="flex-shrink-0 px-3 py-1.5 font-medium text-xs text-white rounded-lg transition-colors">
                    {`+ ${t('create one')}`}
                </Button>
                <Modal
                    className="custom-modal"
                    destroyOnHidden
                    footer={null}
                    title={
                        <div className="text-center text-color-000 font-bold uppercase">
                            {t('Invite your friends to this page')}
                        </div>
                    }
                    maskClosable
                    open={isToggle}
                    onCancel={() => {
                        setListKey(new Date().getTime())
                        toggle()
                    }}>
                    <Invite item={item}/>
                </Modal>
            </div>
            <div className="rounded-xl border border-color-50 shadow-sm overflow-hidden">
                <div className="px-4 py-2 background-100 border-b border-color-50">
                    <InviteRowHeader/>
                </div>
                <div className="divide-y divide-color-50">
                    <LazyPagination
                        key={listKey}
                        query={{
                            ':prop': containerType,
                            ':id': containerId
                        }}
                        renderEmpty={() => (
                            <EmptyHolder
                                subTitle={t('no invites yet')}
                            />
                        )}
                        apiInfo={referral_getReferrals_Api}
                        renderItem={item => item && (
                            <InviteRow
                                className="px-4 py-2.5"
                                {...{
                                    inviter: (
                                        <span className="text-sm font-bold text-color-000">
                                {item.creator.name || 'NaN'}
                            </span>
                                    ),
                                    invite_code: (
                                        <div
                                            onClick={() => {
                                                copyLink(
                                                    ROOT_URL +
                                                    '/invite/organization/' +
                                                    item.referral_code
                                                )
                                            }}
                                            className="font-bold text-sm text-orange-600 cursor-pointer">
                                            {item.referral_code}
                                            <TooltipApp title={t('copy')}
                                                        className="text-color-500 hover:text-color-100 cursor-pointer ml-2">
                                                <MdOutlineFileCopy/>
                                            </TooltipApp>
                                        </div>
                                    ),
                                    uses: (
                                        <div className="text-right font-bold text-color-000 text-sm">
                                            {item.total_accepts || 0}
                                        </div>
                                    ),
                                    expires: (
                                        <div className="text-xs italic font-light text-color-400 text-right">
                                            {
                                                _.isEmpty(item.expired) ? "" : (
                                                    <Timestamp
                                                        timestamp={
                                                            item.expired
                                                        }
                                                    />
                                                )
                                            }
                                        </div>
                                    ),
                                    actions: (
                                        <AsyncAction
                                            apiInfo={
                                                referral_deleteReferral_Api
                                            }
                                            query={{
                                                ':referral_id':
                                                item.id
                                            }}>
                                            {({
                                                  handleAsyncAction,
                                                  isLoading,
                                                  success
                                              }) =>
                                                success ? (
                                                    <div className="text-xs text-red-300 text-right italic">
                                                        {t('deleted')}
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center justify-end">
                                                        {
                                                            isLoading ?
                                                                <LoadingOutlined/> :
                                                                <BsTrash
                                                                    className="text-red-300 hover:text-red-600 cursor-pointer"
                                                                    onClick={() =>
                                                                        handleAsyncAction()
                                                                    }
                                                                />
                                                        }
                                                    </div>
                                                )
                                            }
                                        </AsyncAction>
                                    )
                                }}
                            />
                        )
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default InviteManager
